// dashboardLayoutRoutes.config.ts
export const DASHBOARD_LAYOUT_ROUTES: Record<number, string> = {
  1: "/dashboard",
  2: "/alternative-dashboard/TreasuryDashboard",
  3: "/alternative-dashboard/ApprovalsWorkspace",
  4: "/alternative-dashboard/InsightsCFOCopilot",
  5: "/alternative-dashboard/CompactWidgets",
};

export const ROUTE_TO_LAYOUT_ID: Record<string, number> = Object.entries(
  DASHBOARD_LAYOUT_ROUTES,
).reduce(
  (acc, [layoutId, path]) => {
    acc[path] = Number(layoutId);
    return acc;
  },
  {} as Record<string, number>,
);
